import { render, staticRenderFns } from "./share_dialog.vue?vue&type=template&id=63c0a660&"
import script from "./share_dialog.vue?vue&type=script&lang=js&"
export * from "./share_dialog.vue?vue&type=script&lang=js&"
import style0 from "./share_dialog.vue?vue&type=style&index=0&id=63c0a660&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports